import { Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export enum CategoryTypeEnum {
  BASIC = "basic",
  STANDARD = "standard",
  PREMIUM = "premium"
}
export enum UserStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SUSPENDED = "suspended"
}
export enum KycStatusEnum {
  COMPLETED = "completed",
  REJECTED = "rejected",
  PENDING = "pending"
}

@Component({
  selector: 'app-add-distributor-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-distributor-modal.component.html',
  styleUrls: ['./add-distributor-modal.component.scss']
})
export class AddDistributorModalComponent {
  @Input() isEdit = false;
  @Input() distributor: any = {
    distributor_code: '',
    distributor_name: '',
    status: UserStatusEnum.ACTIVE,
    email: '',
    phone_number: '',
    alt_phone_number: null,
    gst: '',
    pan: '',
    distributor_agency: '',
    address_line1: '',
    address_line2: '',
    pincode: '',
    state: '',
    city: '',
    kyc_status: KycStatusEnum.PENDING,
    category: CategoryTypeEnum.BASIC
  };

  @Output() close = new EventEmitter<void>();
  @Output() submitDistributor = new EventEmitter<any>();

  categoryTypes = Object.values(CategoryTypeEnum);
  userStatuses = Object.values(UserStatusEnum);
  kycStatuses = Object.values(KycStatusEnum);

  submitting = false;
  errorMsg = '';
  fieldErrors: { [key: string]: string } = {};

  pinLocationVerified = false;

  constructor(private http: HttpClient) {}

  onPincodeChange(pincode: string) {
    if (pincode && pincode.toString().trim().length === 6) {
      this.http.get<any>(`${environment.apiBaseUrl}/admin/external/pincode/${pincode.toString().trim()}`).subscribe({
        next: (res) => {
          if (res && res.data && res.data[0] && res.data[0].Status === 'Success' && res.data[0].PostOffice && res.data[0].PostOffice.length > 0) {
            const postOffice = res.data[0].PostOffice[0];
            this.distributor.city = postOffice.District || postOffice.Block;
            this.distributor.state = postOffice.State;
            this.pinLocationVerified = true;
          } else {
            this.pinLocationVerified = false;
          }
        },
        error: () => {
          this.pinLocationVerified = false;
        }
      });
    } else {
      this.pinLocationVerified = false;
    }
  }

  validate() {
    this.fieldErrors = {};
    // Distributor Code
    if (!this.distributor.distributor_code) {
      this.fieldErrors['distributor_code'] = 'Distributor Code is required.';
    }
    // Distributor Name
    if (!this.distributor.distributor_name) {
      this.fieldErrors['distributor_name'] = 'Distributor Name is required.';
    }
    // Status - removed validation, will use default
    // Email
    if (!this.distributor.email) {
      this.fieldErrors['email'] = 'Email is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.distributor.email)) {
      this.fieldErrors['email'] = 'Invalid email format.';
    }
    // Phone Number
    if (!this.distributor.phone_number) {
      this.fieldErrors['phone_number'] = 'Phone Number is required.';
    } else if (!/^\d{10,}$/.test(String(this.distributor.phone_number))) {
      this.fieldErrors['phone_number'] = 'Invalid phone number.';
    }
    // Alt Phone Number (optional)
    if (this.distributor.alt_phone_number && !/^\d{10,}$/.test(String(this.distributor.alt_phone_number))) {
      this.fieldErrors['alt_phone_number'] = 'Invalid alternate phone number.';
    }
    // GST (optional)
    // PAN
    if (!this.distributor.pan) {
      this.fieldErrors['pan'] = 'PAN Number is required.';
    }
    // Address Line 1
    if (!this.distributor.address_line1) {
      this.fieldErrors['address_line1'] = 'Address Line 1 is required.';
    }
    // Pincode
    if (!this.distributor.pincode) {
      this.fieldErrors['pincode'] = 'Pincode is required.';
    } else if (!/^\d{6}$/.test(String(this.distributor.pincode))) {
      this.fieldErrors['pincode'] = 'Invalid pincode.';
    }
    // State
    if (!this.distributor.state) {
      this.fieldErrors['state'] = 'State is required.';
    }
    // City
    if (!this.distributor.city) {
      this.fieldErrors['city'] = 'City is required.';
    }
    // Remove category and kyc_status validation as they're hidden
    // Category and KYC Status will use default values

    return Object.keys(this.fieldErrors).length === 0;
  }

  onSubmit() {
    this.errorMsg = '';
    if (!this.validate()) {
      this.errorMsg = 'Please fix the errors above.';
      return;
    }
    this.submitting = true;
    // Default values will be sent automatically
    this.submitDistributor.emit(this.distributor);
  }

  resetSubmitting() {
    this.submitting = false;
  }

  onClose() {
    this.close.emit();
  }
}
